export default __webpack_public_path__ + "static/swatches-d99b9e264bdcb7b32a6fc8e3ca93a6ef.png";